import { Component, AfterViewInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetOrderService } from '../../services/asset-order.service';
import { AssetProductLov } from '../asset-product-lov/asset-product-lov.component';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { AssetOrder } from '../../models/entities/asset-order';
import { AssetOrderLine } from '../../models/entities/asset-order-line';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'asset-order-widget',
    templateUrl: './asset-order-widget.component.html',
    styleUrls: ['./asset-order-widget.component.scss']
})

export class AssetOrderWidgetComponent extends BaseWidget implements AfterViewInit {

  assetOrder               : AssetOrder = new AssetOrder();
  assetOrderLineColumns   = [];
  
 

  constructor(
      protected assetOrderService : AssetOrderService,
      protected toastr            : ToastrService,
      protected dialog            : MatDialog,
      protected leanUtilsService  : LeanUtilsService) {
      super(toastr, leanUtilsService);
  }



ngAfterViewInit(): void {

  super.ngAfterViewInit();
        
  
  setTimeout(() => {
    this.setAssetOrderLineColumns();
  })
}

 //--------------------------------------------------------------------------------------------------------
 setEntity(assetOrder: AssetOrder) {
      this.assetOrder  = { ...assetOrder };
      this.assetOrder.assetOrderLines = [];
      if (assetOrder.assetOrderLines) {
        for (let assetOrderLine of assetOrder.assetOrderLines) {
          this.assetOrder.assetOrderLines.push({ ...assetOrderLine });
        }
      }
  }
 //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.assetOrder;
  }
  //--------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
  newAssetOrderLine(){
  let dialogRef = this.dialog.open(AssetProductLov);
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.setAssetProduct(result);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------


  setAssetProduct(assetProduct : AssetProduct){
    let nr : AssetOrderLine = new AssetOrderLine();
    nr.inserted           = true;
    nr.edit               = true;
    nr.assetProduct       = assetProduct;
    nr.quantity           = 0;
    nr.deliveredQuantity  = 0;
    this.assetOrder.assetOrderLines.push(nr);

    this.assetOrder.assetOrderLines = [...this.assetOrder.assetOrderLines];  
  }

/*


  setSelectedPartner(result : DataModalResponse){
    let partner = result.selectedRow as Partner;
    this.assetOrder.partner = partner;
  }


<partner-lov  #partnerLov
  (onSelect) = "setSelectedPartner($event)">
</partner-lov>

<asset-product-lov  #assetProductLov
  (onSelect)  = "setAssetProduct($event)">
</asset-product-lov>
*/



  //------------------------------------------------------
  saveRow() : Promise<AssetOrder>{
    if (! this.assetOrder.assetOrderCode){
      this.toastr.error("Code du bon de commande manquant !");
      return;
    }
    if (! this.assetOrder.theDate){
      this.toastr.error("Date du bon de commande manquante !");
      return;
    }
    if ((! this.assetOrder.assetOrderLines) || (this.assetOrder.assetOrderLines.length == 0)){
      this.toastr.error("Aucune ligne produit n'a été saisie dans ce bon commande");
      return;
    }

    if (this.assetOrder.assetOrderLines) {
      let i = 0;
      this.assetOrder.assetOrderLines.forEach(aol => {
        if (aol.quantity <= 0) {
          i++;
        }
      });
      if (i> 0) {
        this.showError("Les quantités commandées doivent être supérieures à 0.     Nombre de lignes avec des quantités négatives ou nulle : " + i);
        return;
      }
    }
    return this.assetOrderService.assetOrderSave(this.assetOrder);
  }
  //------------------------------------------------------



  setAssetOrderLineColumns(){
    this.assetOrderLineColumns =[
      { prop : 'assetProduct.name',           name : 'Produit',      readOnly : true },
      { prop : 'quantity',                    name : 'Qté',         type : 'number'},
    ]
  }
  
}
